import Inputs from './inputs'

const CreationSourceEditorCaptionPanel = () => <Inputs />

export default CreationSourceEditorCaptionPanel
